import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import AgentReferralFormSection from "../components/AgentReferralFormSection";

const AgentReferralForm = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-navy-50 font-body py-12 px-6" data-testid="agent-referral-form-page">
      <div className="max-w-3xl mx-auto mb-8 flex items-center justify-between">
        <Link
          to="/preciosagentes"
          className="inline-flex items-center gap-2 text-navy-600 hover:text-navy-900 text-sm font-medium"
          data-testid="agent-referral-back-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver a los planes
        </Link>
        <span className="text-xs uppercase tracking-widest text-navy-400 font-semibold">
          Formulario · Agentes
        </span>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto text-center mb-10"
      >
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900 mb-3">
          Envío de información para asesoramiento
        </h1>
        <p className="text-navy-600">
          Completa los datos del cliente para que nuestro equipo comience el asesoramiento migratorio.
        </p>
      </motion.div>

      <AgentReferralFormSection />

      <div className="max-w-3xl mx-auto mt-6 text-center">
        <Button variant="outline" onClick={() => navigate("/")} data-testid="agent-referral-back-home-btn">
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default AgentReferralForm;
